import { Paper } from '@mui/material'
import { useEvent } from '../events/EventContext'
import { SectionPage } from '../events/SectionPage'
import { PositionList } from '../positions/PositionList'

export function PositionsPage() {
  const { event } = useEvent()
  return (
    <SectionPage title={event.role === 'organizer' ? 'Postes et fiches' : 'Postes'}>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <PositionList slug={event.slug} role={event.role} />
      </Paper>
    </SectionPage>
  )
}
